<header class="header">
	<div class="header__wrapper">
		<div class="title">
			<h1 class="title__headline"><a [routerLink]="'/intro'" class="logo__link">Hess Smart City</a></h1>
		</div>
		<div class="navigation">
			<a *ngFor="let item of navigation" [routerLink]="['/portal/stage', item.link]" class="navigation__item">{{ item.navigation[language] }}</a>
		</div>
		<div class="logo">
			<img src="assets/images/logo.svg" alt="Hess" class="logo__image" (tap)="toggleSidebar()" />
		</div>
	</div>
</header>


// WEBPACK FOOTER //
// /var/data/workspace/hess/hess_smart_city_web/src/app/components/header/header.component.html